// extracted by mini-css-extract-plugin
export var cardIcon = "_ao-4";
export var checkboxCard = "_ao-0";
export var checkboxCardSelected = "_ao-3";
export var disabled = "_ao-1";
export var outerBorder = "_ao-2";
export var spacerMedium = "_ao-7";
export var spacerSmall = "_ao-6";
export var spacerXsmall = "_ao-5";